<template>
	<div>
		<v-layout>
			<transition name="fade">
				<button
					class="sensorContainer"
					v-bind:style="{ visibility: showSensors ? 'visible' : '' }"
					disabled
				>
					<v-badge v-if="sensors && sensors.fuelcardIn >= 0 && unitId">
						<v-icon :color="sensors.fuelcardIn ? 'green' : 'red'"
							>local_gas_station</v-icon
						>
					</v-badge>
					<v-badge v-if="sensors && sensors.keyIn >= 0 && unitId">
						<v-icon :color="sensors.keyIn ? 'green' : 'red'">vpn_key</v-icon>
					</v-badge>
					<!--   <v-badge>
            <v-icon :color="sensors.closed ? 'green' : 'red'">lock</v-icon>
          </v-badge>-->
					<v-badge v-if="sensors && sensors.battery >= 0">
						<device-battery
							v-if="sensors && sensors.battery"
							class="right"
							style="transform: translate(50%, 0);"
							:percentage="sensors.battery"
						></device-battery>
					</v-badge>

					<span class="refresher">
						<v-icon @click="refresh()" v-if="showRefresh">refresh</v-icon>
						<v-progress-circular
							:size="20"
							indeterminate
							v-if="!showRefresh"
							style="transform: translate(0,5px);"
						></v-progress-circular>
					</span>
				</button>
			</transition>
			<v-btn v-show="loading" flat disabled class="elevation-0">
				<v-progress-circular
					indeterminate
					color="primary"
				></v-progress-circular>
			</v-btn>
			<v-menu bottom left offset-y v-if="unitId" class="dialogDropdown">
				<span slot="activator" flat v-show="!loading">
					<v-icon color="blue">phonelink_lock</v-icon>
				</span>
				<v-list
					class="dialogDropdown"
					menu-props="{'contentClass':'dialogDropdown','bottom':true}"
				>
					<v-list-tile
						v-for="(item, i) in items"
						:key="i"
						@click="sendCommand(i)"
					>
						<v-list-tile-title>{{ item.title }}</v-list-tile-title>
					</v-list-tile>
				</v-list>
			</v-menu>
		</v-layout>
	</div>
</template>

<script>
import * as utils from '@/utils/utils';
import DeviceBattery from '@/components/Units/DeviceBattery';
export default {
	name: 'UnitControl',
	components: { DeviceBattery },
	data() {
		return {
			utils: utils,
			successMsg: false,
			loading: false,
			items: [
				{
					title: 'Openen'
				},
				{
					title: 'Sluiten'
				},
				{
					title: 'Onderbreking aan'
				},
				{
					title: 'Onderbreking uit'
				}
			]
		};
	},
	props: ['unitId', 'sensors', 'status', 'showRefresh'],
	created() {},
	computed: {
		showSensors() {
			return this.sensors ? Object.keys(this.sensors).length > 0 : false;
		}
	},
	methods: {
		sendCommand(index) {
			var self = this;
			self.loading = true;
			self.successMsg = false;
			utils
				.getData(
					basePath + 'api/rentunits/sendCommand/' + this.unitId + '/' + index
				)
				.then(function(response) {
					self.loading = false;
					if (response && response.data && response.data.success) {
						self.successMsg = true;
						window.emitter.$emit('showToastMessage', {
							msg: 'Commando verzonden'
						});
					}
					if (!self.successMsg) {
						window.emitter.$emit('showToastMessage', {
							msg:
								'ERROR: Commando verzonden: ' +
								(response && response.data ? response.data.msg : ''),
							type: 'error'
						});
					}
				});
		},
		refresh() {
			this.$emit('refreshSensors');
		}
	}
};
</script>
<style lang="scss" scoped>
.sensorContainer {
	position: relative;
	.refresher {
		position: absolute;
		left: 0;
		right: 0;
		margin: 0 auto;
		top: 10px;
		display: none;
	}
	&:hover {
		.refresher {
			display: inline;
		}
		> span.v-badge {
			opacity: 0.2;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Units/UnitControl.vue